import React from 'react';
import { useWeb3 } from '@/hooks/useWeb3';

export const WalletButton: React.FC = () => {
  const { isConnected, address, connectWallet, disconnectWallet, openModal, formatAddress } = useWeb3();

  if (!isConnected || !address) {
    return (
      <button
        onClick={connectWallet}
        className="flex items-center space-x-2 px-5 py-2.5 bg-primary hover:bg-primary-light text-dark font-semibold rounded-xl transition-all duration-200 shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/30 hover:scale-105"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path>
        </svg>
        <span>Connect Wallet</span>
      </button>
    );
  }

  return (
    <div className="flex items-center space-x-3">
      <button
        onClick={openModal}
        className="flex items-center space-x-2 px-4 py-2.5 glass-effect border border-primary/20 hover:border-primary/40 rounded-xl transition-all duration-200 group"
      >
        <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
        <span className="text-gray-200 font-medium group-hover:text-primary transition-colors">
          {formatAddress(address)}
        </span>
        <svg className="w-4 h-4 text-gray-400 group-hover:text-primary transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </button>
      <button
        onClick={disconnectWallet}
        className="p-2.5 glass-effect border border-red-500/20 hover:border-red-500/40 rounded-xl transition-all duration-200 group"
        title="Disconnect"
      >
        <svg className="w-5 h-5 text-red-400 group-hover:text-red-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path>
        </svg>
      </button>
    </div>
  );
};
